module.exports = __webpack_public_path__ + "img/NEWCR2.3649ab29.svg";